const deliveryModes = {
    Pickup: "Pickup",
    Dropoff: "Dropoff" 
};

export {
    deliveryModes
}